export const translations = {
  pt: {
    navbar: {
      industry: "Indústria",
      services: "Serviços",
      carrers: "Carreiras",
      products: {
        tab_label: "Produtos"
      },
      cases: {
      cases: "Cases",
      title: "Projetos personalizados, com excelência em qualidade.",
      viewAll: "Ver todos os cases",
      },
      contact: "Entrar em contato",
      industries: {
        agribusiness: "Agronegócio",
        education: "Educação",
        logistics: "Logística",
        streaming: "Streaming",
        retail: "Varejo e Moda",
        betting: "Bets e iGaming",
        financial: "Financeiro",
        startups: "Startups",
        technology: "Tecnologia"
      }
    },
    hero: {
      title: "Desenvolvendo Sucesso",
      subtitle: "Transformando ideias em realidade digital",
      description: "Soluções tecnológicas inovadoras para impulsionar seu negócio",
      hero14: {
        title: "Engenharia de Precisão: Do Projeto à Escala,",
        highlight: "Gerando Valor para seu Negócio"
      }
    },
    requestDemo: {
      title: "Solicite um Demo - InfiniteDev",
      pageTitle: "Solicite um Demo"
    },
    features: {
      title: "Nossos Diferenciais",
      subtitle: "Por que escolher a InfiniteDev",
      featureFive: {
        title: "A InfiniteDev é seu parceiro estratégico para desenvolvimento de soluções tecnológicas de alta performance que geram impacto real.",
        highlight: "",
        subtitle: "",
        categories: {
          professionals: {
            category: "PROFISSIONAIS HIGH-END",
            title: "aumente seu time",
            subtitle: "de tecnologia.",
            outsourcing: {
              title: "Outsourcing de tecnologia sob medida.",
              desc: "Monte times ágeis com os melhores talentos sem precisar contratar diretamente.",
              features: {
                title: "Time certo, no momento certo",
                description: "Especialistas prontos para integrar e acelerar seus projetos com flexibilidade e eficiência.",
                items: [
                  {
                    icon: "fal fa-people-arrows",
                    title: "Flexibilidade Total",
                    desc: "Escale sua equipe conforme a demanda do projeto com profissionais prontos para contribuir."
                  },
                  {
                    icon: "fal fa-handshake",
                    title: "Parceria Estratégica",
                    desc: "Acompanhamento contínuo para garantir performance e alinhamento com seus objetivos."
                  }
                ]
              },
              analytics: {
                title: "Foco em resultados, não em gestão",
                description: "Gestão simplificada, entregas aceleradas e performance garantida.",
                items: [
                  {
                    icon: "fal fa-chart-line",
                    title: "Monitoramento Contínuo",
                    desc: "Acompanhamento de KPIs e entregas para manter o alto desempenho da equipe alocada."
                  },
                  {
                    icon: "fal fa-user-cog",
                    title: "Perfis Adaptáveis",
                    desc: "Profissionais que se moldam às suas ferramentas, cultura e métodos de trabalho."
                  }
                ]
              }
            },

            recruitment: {
              title: "Contrate os melhores profissionais de tecnologia 4x mais rápido.",
  desc: "Perfis validados, alto desempenho e contratação sem burocracia. Comece em poucos dias.",
  features: {
    title: "Recrutamento sem complicação",
    description: "Encontramos talentos de tecnologia alinhados com a cultura e os objetivos do seu negócio, de forma ágil e assertiva.",
    items: [
      {
        icon: "fal fa-users",
        title: "Recrutamento Especializado",
        desc: "Conectamos sua empresa a profissionais de tecnologia qualificados, prontos para entregar resultados."
      },
      {
        icon: "fal fa-rocket",
        title: "Agilidade na Contratação",
        desc: "Reduza o tempo de contratação com um processo eficiente e focado em performance."
      }
    ]
  },
            analytics: {
              title: "Recrutamento focado em performance",
  description: "Nosso processo vai além do currículo: avaliamos soft skills, fit cultural e capacidade técnica real para entregar os melhores talentos.",
  items: [
    {
      icon: "fal fa-user-check",
      title: "Validação Técnica Rigorosa",
      desc: "Profissionais passam por testes práticos e entrevistas técnicas conduzidas por especialistas."
    },
    {
      icon: "fal fa-comments-alt",
      title: "Avaliação de Soft Skills",
      desc: "Analisamos comunicação, adaptabilidade e colaboração para garantir o fit com seu time."
    }
  ]
            }
            },
            rightee: {
  title: "Rightee: A Revolução do Seu Golf Chegou.",
  desc: "O app em score, estatísticas e GPS. Organize seus jogos, acompanhe seu desempenho e evolua seu handicap como nunca antes.",
  features: {
    title: "Tecnologia de Ponta no Campo",
    description: "Tenha em mãos todas as ferramentas para uma partida de golfe mais precisa, divertida e conectada.",
    items: [
      {
        icon: "fal fa-map-marker-alt", // Ícone sugerido para GPS
        title: "GPS Preciso e Detalhado",
        desc: "Distâncias exatas para o green (frente, centro e fundo), obstáculos e layups, com mapas de alta qualidade dos campos."
      },
      {
        icon: "fal fa-file-signature", // Ícone sugerido para Scorecard
        title: "Scorecard Digital Inteligente",
        desc: "Marque seus scores e de seus parceiros com facilidade, acompanhe o jogo em tempo real com o Live Score e utilize diversos formatos de jogo."
      }
    ],
    image: "/assets/img/rightee-watch.png"

  },
  analytics: {
    title: "Estatísticas Completas para Sua Evolução",
    description: "Analise cada detalhe do seu jogo, identifique pontos fortes e fracos, e tome decisões baseadas em dados para baixar seu handicap.",
    items: [
      {
        icon: "fal fa-chart-bar", // Ícone sugerido para Estatísticas
        title: "Acompanhamento de Handicap e Performance",
        desc: "Controle seu handicap oficial ou Rightee, além de estatísticas como GIR, Putts por Rodada, Fairways Acertados e muito mais."
      },
      {
        icon: "fal fa-users", // Ícone sugerido para Jogos e Ranking
        title: "Organização de Jogos e Rankings",
        desc: "Crie e gerencie jogos e torneios com seus amigos, participe de rankings e acompanhe a evolução de todos em tempo real."
      }
    ],
    image: "/assets/img/rightee-round.png"
  },
            },
            grupovisco: {
              title: "Grupo Visco: Inovação Óptica com Tecnologia de Ponta",
              desc: "Há mais de 25 anos sendo referência em lentes oftálmicas. Agora com soluções digitais que transformam a relação entre óticas e laboratório.",
              features: {
                title: "Soluções Digitais para Óticas Modernas",
                description: "O Grupo Visco investe em tecnologia para tornar o atendimento mais ágil, prático e conectado ao dia a dia das óticas.",
                items: [
                  {
                    icon: "fal fa-desktop", // Ícone para plataforma
                    title: "Plataforma Comercial Inteligente",
                    desc: "Visualize catálogos, acompanhe pedidos, acesse o histórico de compras e gerencie tudo em um sistema intuitivo e eficiente."
                  },
                  {
                    icon: "fab fa-slack", // Ícone para Slack
                    title: "Bots no Slack para Atendimento Ágil",
                    desc: "Interação direta com o laboratório via Slack: consulte status de pedidos, prazos e informações técnicas em segundos."
                  }
                ],
                image: "/assets/img/oticas1.png"
              },
              analytics: {
                title: "Automação e Eficiência no Processo Óptico",
                description: "O Grupo Visco conecta seu laboratório aos parceiros com soluções modernas que garantem precisão e agilidade na produção.",
                items: [
                  {
                    icon: "fal fa-server", // Ícone para servidores
                    title: "Sistema de Corte Remoto via FTP",
                    desc: "As óticas enviam seus arquivos diretamente para os servidores da Visco, integrando seus sistemas de medição ao laboratório sem intermediários."
                  },
                  {
                    icon: "fal fa-chart-line", // Ícone para dashboard
                    title: "Dashboard de Pedidos Atrasados",
                    desc: "Visualização em tempo real dos pedidos em atraso no laboratório, permitindo ação rápida e tomada de decisão baseada em dados."
                  }
                ],
                image: "/assets/img/lab1.png"
              }
            },
            cardiohome: {
  title: "Cardiohome: Cuidando da Saúde Escolar com Excelência.",
  desc: "Avaliações médicas completas diretamente nas escolas, com agilidade, profissionalismo e foco no bem-estar dos alunos.",
  features: {
    title: "Atendimento Médico no Ambiente Escolar",
    description: "Equipe especializada leva exames completos até a escola, promovendo saúde de forma prática e humana.",
    items: [
      {
        icon: "fal fa-user-md", // Ícone sugerido para atendimento médico
        title: "Exames Médicos Completos",
        desc: "Avaliação física, visão, audição, coluna e muito mais. Tudo entregue em PDF com prazo de até 5 dias úteis."
      },
      {
        icon: "fal fa-hands-helping", // Ícone sugerido para parceria com escolas
        title: "Atendimento Personalizado",
        desc: "Serviço adaptado à realidade de cada instituição, com comunicação clara e foco no bem-estar das crianças."
      }
    ],
    image: "/assets/img/cardiohome-page.png"
  },
  analytics: {
    title: "Compromisso com Qualidade e Evolução",
    description: "Desde 2019, entregando excelência em saúde escolar com equipe multidisciplinar e foco humano.",
    items: [
      {
        icon: "fal fa-star", // Ícone sugerido para qualidade
        title: "Excelência Reconhecida",
        desc: "Pontuação máxima em licitações públicas, com foco em ética, agilidade e cuidado verdadeiro."
      },
      {
        icon: "fal fa-users-class", // Ícone sugerido para comunidade escolar
        title: "Parceria com Escolas e Programas",
        desc: "Atuação conjunta com escolas e PIE para garantir atenção integral aos alunos."
      }
    ],
    image: "/assets/img/formularioUnico.jpeg"
  }
},
careers: {
  title: "InfiniteDev: Transforme o Futuro com a Gente.",
  desc: "Junte-se a uma equipe apaixonada por inovação, onde cada projeto é uma oportunidade de crescimento e impacto real.",
  features: {
    title: "Por que Trabalhar na InfiniteDev?",
    description: "Na InfiniteDev, valorizamos a colaboração, a criatividade e o compromisso com a excelência. Aqui, você encontrará:",
    items: [
      {
        icon: "fal fa-users", // Ícone sugerido para equipe
        title: "Equipe Colaborativa",
        desc: "Trabalhe ao lado de profissionais talentosos em um ambiente que estimula o aprendizado contínuo e a troca de conhecimentos."
      },
      {
        icon: "fal fa-lightbulb-on", // Ícone sugerido para inovação
        title: "Projetos Inovadores",
        desc: "Participe de projetos desafiadores que utilizam as tecnologias mais recentes para criar soluções impactantes."
      },
      {
        icon: "fal fa-globe", // Ícone sugerido para alcance global
        title: "Alcance Global",
        desc: "Contribua para soluções que fazem a diferença em empresas ao redor do mundo, ampliando sua experiência e visão de mercado."
      }
    ]
  },
  analytics: {
    title: "Crescimento e Desenvolvimento Profissional",
    description: "Investimos no seu desenvolvimento para que você alcance todo o seu potencial.",
    items: [
      {
        icon: "fal fa-chart-line", // Ícone sugerido para crescimento
        title: "Plano de Carreira",
        desc: "Oferecemos caminhos claros para o crescimento profissional, com metas e feedbacks constantes."
      },
      {
        icon: "fal fa-graduation-cap", // Ícone sugerido para aprendizado
        title: "Aprendizado Contínuo",
        desc: "Acesso a cursos, workshops e recursos que promovem o aprimoramento de habilidades técnicas e comportamentais."
      }
    ]
  }
},
            // outsourcing: {
            //   title: "Outsourcing de tecnologia sob medida.",
            //   desc: "Monte times ágeis com os melhores talentos sem precisar contratar diretamente.",
            //   features: {
            //     title: "Time certo, no momento certo",
            //     description: "Especialistas prontos para integrar e acelerar seus projetos com flexibilidade e eficiência.",
            //     items: [
            //       {
            //         icon: "fal fa-people-arrows",
            //         title: "Flexibilidade Total",
            //         desc: "Escale sua equipe conforme a demanda do projeto com profissionais prontos para contribuir."
            //       },
            //       {
            //         icon: "fal fa-handshake",
            //         title: "Parceria Estratégica",
            //         desc: "Acompanhamento contínuo para garantir performance e alinhamento com seus objetivos."
            //       }
            //     ]
            //   },
            //   analytics: {
            //     title: "Foco em resultados, não em gestão",
            //     description: "Gestão simplificada, entregas aceleradas e performance garantida.",
            //     items: [
            //       {
            //         icon: "fal fa-chart-line",
            //         title: "Monitoramento Contínuo",
            //         desc: "Acompanhamento de KPIs e entregas para manter o alto desempenho da equipe alocada."
            //       },
            //       {
            //         icon: "fal fa-user-cog",
            //         title: "Perfis Adaptáveis",
            //         desc: "Profissionais que se moldam às suas ferramentas, cultura e métodos de trabalho."
            //       }
            //     ]
            //   }
            // },
            topics: {
              recruitment: {
                title: "Recrutamento Tech",
                desc: "Contratar profissionais de TI até 4x mais rápido.",
                link: "Saiba mais"
              },
              outsourcing: {
                title: "Outsourcing / Alocação",
                desc: "Especialistas ou equipes sob demanda pra projetos.",
                link: "Saiba mais"
              }
            }
          },
          software: {
            systems: {
              title: "Sistemas e plataformas robustas para o seu negócio.",
              desc: "Criamos soluções sob medida para automatizar processos e aumentar sua eficiência operacional.",
              features: {
                title: "Soluções que escalam com você",
                description: "Desde ERPs até plataformas personalizadas, desenvolvemos sistemas alinhados ao seu modelo de negócio.",
                items: [
                  {
                    icon: "fal fa-network-wired",
                    title: "Arquitetura Escalável",
                    desc: "Desenvolvemos sistemas preparados para crescer com sua empresa."
                  },
                  {
                    icon: "fal fa-cogs",
                    title: "Automação de Processos",
                    desc: "Elimine tarefas manuais com sistemas integrados e eficientes."
                  }
                ]
              },
              analytics: {
                title: "Tecnologia a serviço da performance",
                description: "Nossas soluções geram insights e otimizam a gestão do seu negócio.",
                items: [
                  {
                    icon: "fal fa-chart-pie",
                    title: "Painéis Inteligentes",
                    desc: "Visualize dados em tempo real e tome decisões mais assertivas."
                  },
                  {
                    icon: "fal fa-plug",
                    title: "Integrações Facilitadas",
                    desc: "Conecte seu sistema com ERPs, CRMs e outras plataformas essenciais."
                  }
                ]
              }
            },
            apps: {
              title: "Aplicativos sob medida para sua ideia ou negócio.",
              desc: "Transforme ideias em aplicativos funcionais, intuitivos e escaláveis.",
              features: {
                title: "Experiência mobile de alto nível",
                description: "Desenvolvemos apps nativos ou híbridos com foco em performance e usabilidade.",
                items: [
                  {
                    icon: "fal fa-mobile-android",
                    title: "Design Responsivo",
                    desc: "Interfaces modernas e adaptadas para todos os dispositivos."
                  },
                  {
                    icon: "fal fa-code",
                    title: "Tecnologia Atualizada",
                    desc: "Utilizamos as melhores stacks para garantir estabilidade e evolução contínua."
                  }
                ]
              },
              analytics: {
                title: "Dados que impulsionam seu app",
                description: "Acompanhamento de uso, comportamento e melhorias contínuas.",
                items: [
                  {
                    icon: "fal fa-analytics",
                    title: "Métricas de Uso",
                    desc: "Saiba como os usuários interagem com seu app e otimize sua experiência."
                  },
                  {
                    icon: "fal fa-bug",
                    title: "Manutenção Preventiva",
                    desc: "Monitoramento proativo para corrigir falhas e manter o app performando."
                  }
                ]
              }
            },
            category: "SOFTWARE HIGH-END",
            title: "desenvolva softwares",
            subtitle: "robustos e confiáveis.",
            topics: {
              systems: {
                title: "Criar Sistemas e Plataformas",
                desc: "Desenvolver um sistema personalizado.",
                link: "Saiba mais"
              },
              apps: {
                title: "Criar Aplicativos",
                desc: "Desenvolver um app personalizado.",
                link: "Saiba mais"
              }
            }
          },
          infrastructure: {
            migration: {
              title: "Migração para a nuvem com segurança e agilidade.",
              desc: "Leve sua infraestrutura para a nuvem com zero dor de cabeça e máxima eficiência.",
              features: {
                title: "Cloud sem complicações",
                description: "Planejamento, execução e suporte em todas as etapas da migração.",
                items: [
                  {
                    icon: "fal fa-cloud-upload",
                    title: "Migração Assistida",
                    desc: "Cuidamos de todo o processo, minimizando riscos e interrupções."
                  },
                  {
                    icon: "fal fa-server",
                    title: "Infraestrutura Otimizada",
                    desc: "Escolha a melhor arquitetura cloud para seu negócio."
                  }
                ]
              },
              analytics: {
                title: "Ganhos reais com a nuvem",
                description: "Acompanhe redução de custos, performance e escalabilidade após a migração.",
                items: [
                  {
                    icon: "fal fa-dollar-sign",
                    title: "Economia Mensurável",
                    desc: "Corte custos operacionais com uma infraestrutura mais enxuta e elástica."
                  },
                  {
                    icon: "fal fa-tachometer-alt",
                    title: "Performance Garantida",
                    desc: "Serviços com alta disponibilidade e baixo tempo de resposta."
                  }
                ]
              }
            },
            management: {
              title: "Gestão de infraestrutura sem estresse.",
              desc: "Monitoramento, otimização e suporte contínuo para manter tudo funcionando.",
              features: {
                title: "Tranquilidade para focar no seu negócio",
                description: "Cuidamos da sua infraestrutura para que você foque em crescer.",
                items: [
                  {
                    icon: "fal fa-tools",
                    title: "Suporte 24/7",
                    desc: "Equipes prontas para atuar a qualquer momento em casos críticos."
                  },
                  {
                    icon: "fal fa-sliders-h",
                    title: "Otimização Contínua",
                    desc: "Análises periódicas para reduzir gargalos e aumentar a performance."
                  }
                ]
              },
              analytics: {
                title: "Controle total da sua operação",
                description: "Tenha visibilidade de tudo que acontece com sua infraestrutura.",
                items: [
                  {
                    icon: "fal fa-eye",
                    title: "Monitoramento Ativo",
                    desc: "Alertas e métricas em tempo real para tomar decisões rápidas."
                  },
                  {
                    icon: "fal fa-database",
                    title: "Relatórios Detalhados",
                    desc: "Informações consolidadas para auditoria e melhoria contínua."
                  }
                ]
              }
            },
            category: "INFRAESTRUTURA HIGH-END",
            title: "evolua sua operação",
            subtitle: "em nuvem.",
            topics: {
              migration: {
                title: "Migração Cloud",
                desc: "Migrar sistemas e dados para a nuvem ou entre provedores Cloud.",
                link: "Saiba mais"
              },
              management: {
                title: "Gerenciar e Otimizar",
                desc: "Gestão cloud, aumentar segurança e reduzir custos.",
                link: "Saiba mais"
              }
            }
          },
          ai: {
            generative: {
              title: "Transforme sua empresa usando Inteligência Artificial Generativa",
              desc: "",
              features: {
                title: "Criação e automação com IA",
                description: "Aplique IA para criar conteúdos, responder clientes ou gerar códigos automaticamente.",
                items: [
                  {
                    icon: "fal fa-robot",
                    title: "Conteúdo Inteligente",
                    desc: "Geração de textos, imagens ou ideias com IA de ponta."
                  },
                  {
                    icon: "fal fa-magic",
                    title: "Automação Criativa",
                    desc: "Otimize tarefas repetitivas com assistentes inteligentes personalizados."
                  }
                ]
              },
              analytics: {
                title: "Resultados além do esperado",
                description: "Ganhe produtividade, reduza custos e surpreenda seus clientes.",
                items: [
                  {
                    icon: "fal fa-bolt",
                    title: "Produtividade Exponencial",
                    desc: "Acelere fluxos de trabalho com inteligência artificial aplicada."
                  },
                  {
                    icon: "fal fa-smile",
                    title: "Experiência do Usuário",
                    desc: "Crie interações únicas com IA generativa ajustada ao seu público."
                  }
                ]
              }
            },
            custom: {
              title: "IA sob medida para sua empresa.",
              desc: "Desenvolvemos modelos de IA personalizados para seus dados e objetivos.",
              features: {
                title: "IA feita para você",
                description: "Modelos de machine learning desenvolvidos para resolver seus desafios específicos.",
                items: [
                  {
                    icon: "fal fa-brain",
                    title: "Modelagem Personalizada",
                    desc: "Construção e treinamento de modelos com seus próprios dados."
                  },
                  {
                    icon: "fal fa-puzzle-piece",
                    title: "Integração com Sistemas",
                    desc: "IA funcionando com suas ferramentas e fluxos atuais."
                  }
                ]
              },
              analytics: {
                title: "Decisões mais inteligentes",
                description: "Ganhe insights estratégicos com dados analisados por modelos avançados.",
                items: [
                  {
                    icon: "fal fa-lightbulb",
                    title: "Análise Preditiva",
                    desc: "Antecipe cenários e tome decisões baseadas em dados reais."
                  },
                  {
                    icon: "fal fa-sync-alt",
                    title: "Ajustes Contínuos",
                    desc: "Modelos que aprendem e evoluem com o tempo para melhores resultados."
                  }
                ]
              }
            },
            category: "IA HIGH-END",
            title: "use Inteligência Artificial",
            subtitle: "para transformar.",
            topics: {
              generative: {
                title: "Criar uma IA Generativa",
                desc: "Gerar informações, converter e interpretar textos, imagens e mais.",
                link: "Saiba mais"
              },
              custom: {
                title: "Criar uma IA Personalizada",
                desc: "IA para áreas específicas do seu negócio.",
                link: "Saiba mais"
              }
            }
          }
        }
      }
    },
    contact: {
      title: "Vamos Conversar",
      subtitle: "Entre em contato conosco",
      button: "Fale Conosco"
    },
    integration: {
      title: "Integrações",
      subtitle: "Conectamos com as melhores plataformas"
    },
    products: {
      title: "Nossos Produtos",
      subtitle: "Soluções completas para seu negócio"
    },
    testimonials: {
      title: "O que nossos clientes felizes dizem sobre nós.",
      subtitle: "",
      reviews: [
        {
          title: "5 avaliações em média no nosso app",
          text: `
          Trabalhar com a InfiniteDev tem sido uma experiência extremamente positiva. A qualidade dos serviços de desenvolvimento de aplicativos mobile é notável. A InfiniteDev é nossa parceira inestimável e a recomendamos 100% para quem está buscando esse tipo de serviço.
          `,
          author: "Guilherme Ribeiro",
          role: "CEO Rightee Golf"
        },
        {
          title: "o profissionalismo na realização do trabalho tem sido excelente",
          text: "Na nossa empresa, CARDIOHOME SPA, foi fundamental incorporar o sistema desenvolvido pela infinitedev. Agilizou o nosso processo e otimizou os tempos, o que é fundamental para nós, já que nossos serviços são caracterizados pela atenção massiva aos pacientes.",
          author: "Jorge Kirk",
          role: "CEO CardioHome"
        },
        // {
        //   title: "$0.00 tudo é GRÁTIS",
        //   text: "Excelente experiência com o serviço de TI prestado. A equipe foi profissional, atenciosa e solucionou todas as demandas com agilidade. A comunicação foi clara durante todo o processo e o suporte técnico superou as expectativas. Recomendo!",
        //   author: "Richard Tea",
        //   role: "Gerente"
        // }
      ]
    },
    cta: {
      title: "Pronto para começar?",
      subtitle: "Vamos transformar sua ideia em realidade",
      button: "Comece Agora"
    },
    contactButton: {
      text: "Falar com a InfiniteDev"
    },
    integrations: {
      title: "Confiada por Líderes da Indústria em Todo o Mundo",
      apps: {
        rightee: {
          name: "Rightee",
          description: "Aplicativo de golfe para score e estatísticas."
        },
         grupovisco: {
          name: "Grupo Visco",
          description: "CRM, Painel BI e Automação de negócios para o maior laboratório ótico do Brasil "
        },
               enero: {
          name: "Enero Comunicación",
          description: "Site institucional para agência de Marketing Argentina"
        },
          calbamerica: {
          name: "Calbamerica",
          description: "Camara Latinoamericana de Lítio - Transformação Digital"
        },
          mmarg: {
          name: "Mercado de Metales",
          description: "Sistema de captação de investidores para mineração"
        },
          tecnoedil: {
          name: "Tecnoedil",
          description: "Plataforma de cotação e registro de provedores"
        },
        cardiohome: {
          name: "Cardiohome",
          description: "Plataforma de Avaliações médicas em ambiente escolar."
        },
        
        xhockware: {
          name: "Xhockware",
          description: "Líder global em software para Retail"
        },
        youbeep: {
          name: "YouBeep",
          description: "Inovação em soluções de checkout para varejo."
        },
        quilmes: {
          name: "Quilmes",
          description: "Maior cervejaria da Argentina."
        },
        gob: {
          name: "Gobierno BsAs",
          description: "Governo da Cidade de Buenos Aires."
        }
      }
    },
    cases: {
      title: "Cases que comprovam competência",
      products: [
        {
          title: "Rightee",
          description: "Desenvolvemos um aplicativo completo de golfe com GPS de alta precisão, scorecard digital e estatísticas avançadas. Nossa solução permitiu evolução de handicap e gerenciamento de torneios em tempo real."
        },
        {
          title: "Cardiohome",
          description: "Criamos um sistema integrado para gestão de avaliações médicas em escolas, com geração automatizada de relatórios e interface intuitiva para profissionais de saúde."
        },
        {
          title: "Grupo Visco",
          description: "Criamos CRM, BI e automações que integraram processos e aumentaram a eficiência do maior laboratório ótico do Brasil."
        }
      ]
    },
    cyberCta: {
      title: "Discuta Seu Projeto com Nossos Especialistas",
      subtitle: "Receba uma análise técnica e um roadmap transparente para sua solução.",
      button: "Entre em contato"
    },
    footer: {
      newsletter: {
        title: "Nossas últimas notícias, artigos e recursos serão enviados para sua caixa de entrada semanalmente.",
        placeholder: "Digite seu email",
        button: "Inscrever-se"
      },
      rating: {
        title: "10/10 Avaliação geral"
      },
      sections: {
        primary: {
          title: "Páginas Principais",
          links: {
            home: "Início",
            about: "Sobre Nós",
            services: "Serviços",
            career: "Carreiras",
            integrations: "Integrações",
            integrationSingle: "Integração Individual"
          }
        },
        pages: {
          title: "Páginas",
          links: {
            pricing: "Preços",
            blog: "Blog",
            blogDetails: "Detalhes do Blog",
            contact: "Contato",
            careerSingle: "Carreira Individual",
            serviceSingle: "Serviço Individual"
          }
        },
        template: {
          title: "Template",
          links: {
            contact: "Contato",
            support: "Suporte",
            supportSingle: "Suporte Individual",
            comingSoon: "Em Breve",
            login: "Login",
            careerSingle: "Carreira Individual"
          }
        }
      },
      copyright: "© 2025 Infinitedev Todos os direitos reservados."
    },
    services: {
      agronegocio: {
        title: "Agronegócio",
        desc: "Soluções tecnológicas inovadoras para o setor agrícola, otimizando processos e aumentando a produtividade.",
        features: {
          title: "Tecnologia Avançada para o Campo",
          description: "Implementamos soluções digitais que revolucionam a gestão agrícola, desde o plantio até a colheita.",
          items: [
            {
              icon: "fal fa-tractor",
              title: "Gestão de Produção",
              desc: "Controle total da produção com monitoramento em tempo real."
            },
            {
              icon: "fal fa-chart-line",
              title: "Análise de Dados",
              desc: "Insights valiosos para tomada de decisões baseada em dados."
            }
          ]
        },
        analytics: {
          title: "Análise Avançada para Resultados",
          description: "Utilizamos tecnologia de ponta para otimizar cada etapa do processo agrícola.",
          items: [
            {
              icon: "fal fa-comments-alt",
              title: "Suporte Especializado",
              desc: "Equipe técnica especializada em agronegócio."
            },
            {
              icon: "fal fa-headset",
              title: "Monitoramento 24/7",
              desc: "Acompanhamento contínuo da sua produção."
            }
          ]
        }
      },
      educacao: {
        title: "Educação",
        desc: "Transformando a educação através de tecnologia inovadora e soluções digitais personalizadas.",
        features: {
          title: "Plataformas Educacionais Modernas",
          description: "Desenvolvemos soluções que revolucionam a forma de ensinar e aprender.",
          items: [
            {
              icon: "fal fa-graduation-cap",
              title: "EAD Completo",
              desc: "Plataformas completas para ensino a distância."
            },
            {
              icon: "fal fa-book",
              title: "Gestão Escolar",
              desc: "Sistema integrado para administração educacional."
            }
          ]
        },
        analytics: {
          title: "Análise de Desempenho Educacional",
          description: "Ferramentas avançadas para acompanhamento do progresso dos alunos.",
          items: [
            {
              icon: "fal fa-chart-bar",
              title: "Métricas de Aprendizado",
              desc: "Acompanhamento detalhado do desempenho dos alunos."
            },
            {
              icon: "fal fa-users",
              title: "Colaboração",
              desc: "Ferramentas para interação entre alunos e professores."
            }
          ]
        }
      },
      logistica: {
        title: "Logística",
        desc: "Soluções inteligentes para otimização da cadeia logística e gestão de transportes.",
        features: {
          title: "Logística Inteligente",
          description: "Sistemas avançados para gestão eficiente da cadeia logística.",
          items: [
            {
              icon: "fal fa-truck",
              title: "Rastreamento",
              desc: "Monitoramento em tempo real de entregas."
            },
            {
              icon: "fal fa-route",
              title: "Roteirização",
              desc: "Otimização de rotas para maior eficiência."
            }
          ]
        },
        analytics: {
          title: "Análise de Desempenho Logístico",
          description: "Métricas avançadas para otimização de processos.",
          items: [
            {
              icon: "fal fa-map-marked-alt",
              title: "Gestão de Frotas",
              desc: "Controle completo da sua frota de veículos."
            },
            {
              icon: "fal fa-box",
              title: "Gestão de Estoque",
              desc: "Controle preciso de inventário e armazenamento."
            }
          ]
        }
      },
      streaming: {
        title: "Streaming",
        desc: "Plataformas de streaming de alta performance com tecnologia de ponta.",
        features: {
          title: "Streaming de Alta Qualidade",
          description: "Soluções completas para transmissão de conteúdo em tempo real.",
          items: [
            {
              icon: "fal fa-video",
              title: "Transmissão HD",
              desc: "Qualidade de imagem e som premium."
            },
            {
              icon: "fal fa-broadcast-tower",
              title: "Baixa Latência",
              desc: "Transmissão em tempo real com mínima latência."
            }
          ]
        },
        analytics: {
          title: "Análise de Engajamento",
          description: "Métricas detalhadas de audiência e engajamento.",
          items: [
            {
              icon: "fal fa-eye",
              title: "Métricas de Audiência",
              desc: "Análise detalhada do comportamento dos espectadores."
            },
            {
              icon: "fal fa-chart-pie",
              title: "Relatórios",
              desc: "Relatórios completos de desempenho."
            }
          ]
        }
      },
      "varejo-e-moda": {
        title: "Varejo e Moda",
        desc: "Soluções digitais inovadoras para o setor de varejo e moda.",
        features: {
          title: "Varejo Digital",
          description: "Transforme sua operação com tecnologia de ponta.",
          items: [
            {
              icon: "fal fa-shopping-cart",
              title: "E-commerce",
              desc: "Plataformas completas de vendas online."
            },
            {
              icon: "fal fa-tshirt",
              title: "Gestão de Estoque",
              desc: "Controle preciso de produtos e coleções."
            }
          ]
        },
        analytics: {
          title: "Análise de Vendas",
          description: "Insights valiosos para decisões estratégicas.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Métricas de Vendas",
              desc: "Análise detalhada do desempenho comercial."
            },
            {
              icon: "fal fa-users",
              title: "Comportamento do Cliente",
              desc: "Entendimento profundo do seu público."
            }
          ]
        }
      },
      "bets-igaming": {
        title: "Bets e iGaming",
        desc: "Plataformas seguras e inovadoras para o setor de apostas e jogos online.",
        features: {
          title: "Gaming de Alta Performance",
          description: "Soluções completas para operadoras de apostas e jogos.",
          items: [
            {
              icon: "fal fa-dice",
              title: "Plataforma Completa",
              desc: "Sistema integrado para gestão de apostas."
            },
            {
              icon: "fal fa-shield-alt",
              title: "Segurança",
              desc: "Proteção avançada para operações online."
            }
          ]
        },
        analytics: {
          title: "Análise de Desempenho",
          description: "Métricas avançadas para otimização de operações.",
          items: [
            {
              icon: "fal fa-chart-bar",
              title: "Métricas de Jogo",
              desc: "Análise detalhada do comportamento dos jogadores."
            },
            {
              icon: "fal fa-user-shield",
              title: "Compliance",
              desc: "Garantia de conformidade com regulamentações."
            }
          ]
        }
      },
      financeiro: {
        title: "Financeiro",
        desc: "Soluções tecnológicas seguras para o setor financeiro.",
        features: {
          title: "Tecnologia Financeira",
          description: "Sistemas avançados para gestão financeira.",
          items: [
            {
              icon: "fal fa-wallet",
              title: "Gestão Financeira",
              desc: "Controle completo de operações financeiras."
            },
            {
              icon: "fal fa-shield-alt",
              title: "Segurança",
              desc: "Proteção avançada para dados financeiros."
            }
          ]
        },
        analytics: {
          title: "Análise Financeira",
          description: "Insights valiosos para decisões financeiras.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Métricas Financeiras",
              desc: "Análise detalhada de desempenho financeiro."
            },
            {
              icon: "fal fa-file-invoice-dollar",
              title: "Relatórios",
              desc: "Relatórios completos de operações."
            }
          ]
        }
      },
      startups: {
        title: "Startups",
        desc: "Soluções tecnológicas inovadoras para impulsionar seu negócio.",
        features: {
          title: "Tecnologia para Startups",
          description: "Ferramentas essenciais para o crescimento do seu negócio.",
          items: [
            {
              icon: "fal fa-rocket",
              title: "Escalabilidade",
              desc: "Soluções que crescem com seu negócio."
            },
            {
              icon: "fal fa-lightbulb",
              title: "Inovação",
              desc: "Tecnologias de ponta para seu negócio."
            }
          ]
        },
        analytics: {
          title: "Análise de Crescimento",
          description: "Métricas para acompanhar o desenvolvimento.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Métricas de Crescimento",
              desc: "Acompanhamento do desenvolvimento do negócio."
            },
            {
              icon: "fal fa-users",
              title: "Engajamento",
              desc: "Análise do comportamento dos usuários."
            }
          ]
        }
      },
      tecnologia: {
        title: "Tecnologia",
        desc: "Soluções tecnológicas de ponta para empresas de tecnologia.",
        features: {
          title: "Inovação Tecnológica",
          description: "Soluções avançadas para empresas de tecnologia.",
          items: [
            {
              icon: "fal fa-microchip",
              title: "Desenvolvimento",
              desc: "Soluções personalizadas para seu negócio."
            },
            {
              icon: "fal fa-cloud",
              title: "Cloud",
              desc: "Infraestrutura cloud de alta performance."
            }
          ]
        },
        analytics: {
          title: "Análise de Performance",
          description: "Métricas avançadas para otimização.",
          items: [
            {
              icon: "fal fa-tachometer-alt",
              title: "Performance",
              desc: "Monitoramento de desempenho em tempo real."
            },
            {
              icon: "fal fa-chart-bar",
              title: "Métricas",
              desc: "Análise detalhada de sistemas."
            }
          ]
        }
      }
    },
    contactForm: {
      title: "Preencha o formulário e entraremos em contato o mais breve possível.",
      fields: {
        name: "Nome",
        email: "Email",
        companyWebsite: "Site da empresa",
        workEmail: "Email corporativo",
        budget: "Orçamento",
        country: "País",
        message: "Conte-nos mais sobre seu projeto, necessidades e orçamento",
        budgetOptions: {
          default: "Orçamento",
          started: "Nenhum, apenas começando",
          less20k: "Menos de R$ 100.000",
          less50k: "R$ 100.000 a R$ 250.000",
          less100k: "R$ 250.000 a R$ 500.000",
          less500k: "R$ 500.000 a R$ 2.500.000",
          more500k: "Mais de R$ 2.500.000"
        }
      },
      privacy: {
        text: "Sim, gostaria de receber e-mails de marketing ocasionais. Tenho o direito de cancelar a qualquer momento.",
        link: "Ver política de privacidade"
      },
      submit: "Começar",
      sending: "Enviando"
    },
    reviewTab: {
      title: "Como podemos te ajudar?",
      description: "Preencha o formulário para falar com um especialista, ou entre em contato via e-mail ou telefone:",
      testimonials: [
        {
          quote: "Globalmente, atualizamos alinhamentos economicamente sólidos antes de sistemas táticos. Rapidamente atualizamos processos com infomediários tecnicamente sólidos. Holisticamente, buscamos catalisadores de construção de equipe para mudança antes de produtos orientados à equipe.",
          author: "Veronica P. Byrd",
          role: "Técnica veterinária"
        },
        {
          quote: "Sinergicamente, evisculamos o posicionamento de mercado em tecnologia vis-à-vis inovação orientada à equipe. Fosforescentemente, transformamos comunidades táticas para aplicações superiores. Distintamente, pontificamos infomediários de nivelamento de recursos e modelos paralelos.",
          author: "Raymond H. Gilbert",
          role: "Inspetor de incêndios florestais"
        },
        {
          quote: "Profissionalmente, miocardinamos o e-commerce corporativo através de funcionalidades alternativas. Compellingly, matrizamos a convergência distribuída com sinergia orientada a objetivos. Profissionalmente, abraçamos oportunidades interativas através de inovação paralela.",
          author: "Donna R. Book",
          role: "Engenheira extrativa"
        }
      ]
    },
    promoThree: {
      title: "Tudo o que Fazemos é com Amor",
      description: "Progressivamente implantamos catalisadores de posicionamento de mercado para mudança e infraestruturas de nivelamento de recursos tecnicamente sólidas e autoritativamente habilitadas digitalmente.",
      cards: [
        {
          number: "150+",
          title: "Projetos Concluídos",
          description: "Rapidamente abraçamos as melhores práticas distintas após a sindicância B2B."
        },
        {
          number: "1.5k",
          title: "Clientes Satisfeitos",
          description: "Impactamos energeticamente a convergência sinérgica para liderança."
        },
        {
          number: "99.9%",
          title: "Uptime da Plataforma",
          description: "Garantimos alta disponibilidade para que sua operação nunca pare."
        }
      ]
    }
  },
  en: {
    navbar: {
      industry: "Industry",
      services: "Services",
      carrers: "Carrers",
      cases: {
      cases: "Cases",
      title: "Customized projects, with excellence in quality.",
      viewAll: "See All Cases",
      }, // New
      contact: "Contact Us",
      industries: {
        agribusiness: "Agribusiness",
        education: "Education",
        logistics: "Logistics",
        streaming: "Streaming",
        retail: "Retail & Fashion",
        betting: "Betting & iGaming",
        financial: "Financial",
        startups: "Startups",
        technology: "Technology"
      }
    },
    requestDemo: {
      title: "Request a Demo - InfiniteDev",
      pageTitle: "Request a Demo"
    },
    hero: {
      title: "Developing Success",
      subtitle: "Transforming ideas into digital reality",
      description: "Innovative technological solutions to boost your business",
      hero14: {
        title: "Precision Engineering: From Design to Scale,",
        highlight: "Creating Value for Your Business"
      }
    },
    features: {
      title: "Our Differentiators",
      subtitle: "Why choose InfiniteDev",
      featureFive: {
        title: "InfiniteDev is your strategic partner for developing high-performance technological solutions that create real impact.",
        highlight: "",
        subtitle: "",
        categories: {
          professionals: {
            category: "HIGH-END PROFESSIONALS",
            title: "expand your technology team",
            subtitle: "with top-tier talent.",
            outsourcing: {
              title: "Tailored Tech Outsourcing.",
              desc: "Build agile teams with top talent without direct hiring.",
              features: {
                title: "Right Team, Right Time",
                description: "Specialists ready to integrate and accelerate your projects with flexibility and efficiency.",
                items: [
                  {
                    icon: "fal fa-people-arrows",
                    title: "Total Flexibility",
                    desc: "Scale your team according to project demands with professionals ready to contribute."
                  },
                  {
                    icon: "fal fa-handshake",
                    title: "Strategic Partnership",
                    desc: "Continuous support to ensure performance and alignment with your objectives."
                  }
                ]
              },
              analytics: {
                title: "Focus on Results, Not Management",
                description: "Simplified management, accelerated deliveries, and guaranteed performance.",
                items: [
                  {
                    icon: "fal fa-chart-line",
                    title: "Continuous Monitoring",
                    desc: "Tracking KPIs and deliveries to maintain high performance of the allocated team."
                  },
                  {
                    icon: "fal fa-user-cog",
                    title: "Adaptable Profiles",
                    desc: "Professionals who adapt to your tools, culture, and work methods."
                  }
                ]
              }
            },
            rightee: {
  title: "Rightee: Your Golf Game, Revolutionized.",
  desc: "The app for scores, stats, and GPS. Organize your games, track your performance, and improve your handicap like never before.",
  features: {
    title: "Cutting-Edge On-Course Technology",
    description: "All the tools you need for a more precise, fun, and connected round of golf, right at your fingertips.",
    items: [
      {
        icon: "fal fa-map-marker-alt", // Suggested icon for GPS
        title: "Accurate and Detailed GPS",
        desc: "Exact distances to the green (front, center, and back), hazards, and layups, with high-quality course maps."
      },
      {
        icon: "fal fa-file-signature", // Suggested icon for Scorecard
        title: "Smart Digital Scorecard",
        desc: "Easily record your and your partners' scores, follow the game in real-time with Live Score, and use various game formats."
      }
    ]
  },
  analytics: {
    title: "Comprehensive Statistics for Your Improvement",
    description: "Analyze every detail of your game, identify strengths and weaknesses, and make data-driven decisions to lower your handicap.",
    items: [
      {
        icon: "fal fa-chart-bar", // Suggested icon for Statistics
        title: "Handicap and Performance Tracking",
        desc: "Track your official or Rightee handicap, plus statistics like GIR, Putts per Round, Fairways Hit, and much more."
      },
      {
        icon: "fal fa-users", // Suggested icon for Games and Rankings
        title: "Game Organization and Rankings",
        desc: "Create and manage games and tournaments with your friends, participate in rankings, and track everyone's progress in real-time."
      }
    ]
  }
},
grupovisco: {
  title: "Grupo Visco: Optical Innovation Powered by Technology",
  desc: "For over 25 years, Grupo Visco has been a reference in ophthalmic lenses. Now bringing digital solutions that transform the relationship between labs and optical stores.",
  features: {
    title: "Digital Solutions for Modern Optical Stores",
    description: "Grupo Visco invests in technology to make service faster, simpler, and fully integrated into the daily operations of its partners.",
    items: [
      {
        icon: "fal fa-desktop", // Icon for platform
        title: "Smart Commercial Platform",
        desc: "Browse catalogs, track orders, access purchase history, and manage everything in one intuitive and efficient system."
      },
      {
        icon: "fab fa-slack", // Icon for Slack
        title: "Slack Bots for Instant Support",
        desc: "Direct interaction with the lab via Slack: check order status, lead times, and technical details in seconds."
      }
    ],
    image: "/assets/img/oticas1.png"
  },
  analytics: {
    title: "Automation and Efficiency Across Optical Operations",
    description: "Grupo Visco connects its lab with partners through modern solutions that ensure accuracy and speed throughout the process.",
    items: [
      {
        icon: "fal fa-server", // Icon for FTP
        title: "Remote Cutting System via FTP",
        desc: "Optical stores send files directly to Visco's servers, integrating their measuring systems with the lab — no intermediaries needed."
      },
      {
        icon: "fal fa-chart-line", // Icon for dashboard
        title: "Late Orders Dashboard",
        desc: "Real-time dashboard for monitoring delayed orders in the lab, enabling faster response and data-driven decision-making."
      }
    ],
    image: "/assets/img/lab1.png"
  }
},
cardiohome: {
  title: "Cardiohome: Excellence in School Health Care.",
  desc: "Comprehensive medical evaluations delivered directly to schools, with efficiency, professionalism, and a focus on student well-being.",
  features: {
    title: "On-Site Medical Services at Schools",
    description: "A specialized team brings full medical exams to schools, promoting health in a practical and human-centered way.",
    items: [
      {
        icon: "fal fa-user-md", // Suggested icon for medical exams
        title: "Comprehensive Health Screenings",
        desc: "Physical exams, vision, hearing, spine checks, and more. Results delivered as signed PDFs within 5 business days."
      },
      {
        icon: "fal fa-hands-helping", // Suggested icon for school partnership
        title: "Personalized Care",
        desc: "Services tailored to each institution's needs, with clear communication and a genuine focus on children's well-being."
      }
    ],
    image: "/assets/img/cardiohome-page.png"
  },
  analytics: {
    title: "Commitment to Quality and Growth",
    description: "Since 2019, delivering excellence in school health with a multidisciplinary team and a human-first approach.",
    items: [
      {
        icon: "fal fa-star", // Suggested icon for quality
        title: "Recognized Excellence",
        desc: "Top scores in public contracts, with a strong focus on ethics, speed, and authentic care."
      },
      {
        icon: "fal fa-users-class", // Suggested icon for school community
        title: "Partnership with Schools and Programs",
        desc: "Collaborating with schools and special education programs (PIE) to ensure full support for every student."
      }
    ],
    image: "/assets/img/formularioUnico.jpeg"
  }
},
"careers": {
  "title": "InfiniteDev: Shape the Future with Us.",
  "desc": "Join a team driven by innovation, where every project is an opportunity for growth and real impact.",
  "features": {
    "title": "Why Work at InfiniteDev?",
    "description": "At InfiniteDev, we value collaboration, creativity, and a commitment to excellence. Here, you'll find:",
    "items": [
      {
        "icon": "fal fa-users",
        "title": "Collaborative Team",
        "desc": "Work alongside talented professionals in an environment that encourages continuous learning and knowledge sharing."
      },
      {
        "icon": "fal fa-lightbulb-on",
        "title": "Innovative Projects",
        "desc": "Take part in challenging projects that use the latest technologies to build impactful solutions."
      },
      {
        "icon": "fal fa-globe",
        "title": "Global Reach",
        "desc": "Contribute to solutions that make a difference in companies around the world, expanding your experience and market perspective."
      }
    ]
  },
  "analytics": {
    "title": "Growth and Professional Development",
    "description": "We invest in your development so you can reach your full potential.",
    "items": [
      {
        "icon": "fal fa-chart-line",
        "title": "Career Path",
        "desc": "We offer clear paths for career advancement, with constant goals and feedback."
      },
      {
        "icon": "fal fa-graduation-cap",
        "title": "Continuous Learning",
        "desc": "Access to courses, workshops, and resources that foster technical and behavioral skill enhancement."
      }
    ]
  }
},
            recruitment: {
              title: "Hire the best tech professionals 4x faster.",
              desc: "Validated profiles, high performance, and hassle-free hiring. Get started in just a few days.",
              features: {
                title: "Effortless Recruitment",
                description: "We find tech talent aligned with your company's culture and goals, quickly and accurately.",
                items: [
                  {
                    icon: "fal fa-users",
                    title: "Specialized Recruitment",
                    desc: "We connect your company with qualified tech professionals, ready to deliver results."
                  },
                  {
                    icon: "fal fa-rocket",
                    title: "Fast Hiring",
                    desc: "Reduce hiring time with an efficient, performance-focused process."
                  }
                ]
              },
              analytics: {
                title: "Performance-Driven Recruitment",
                description: "Our process goes beyond resumes: we assess soft skills, cultural fit, and real technical ability to deliver top talent.",
                items: [
                  {
                    icon: "fal fa-user-check",
                    title: "Rigorous Technical Validation",
                    desc: "Professionals undergo practical tests and technical interviews conducted by experts."
                  },
                  {
                    icon: "fal fa-comments-alt",
                    title: "Soft Skills Assessment",
                    desc: "We analyze communication, adaptability, and collaboration to ensure a strong team fit."
                  }
                ]
              }
            },
            topics: {
              recruitment: {
                title: "Tech Recruitment",
                desc: "Hire highly qualified IT professionals up to 4x faster.",
                link: "Learn more"
              },
              outsourcing: {
                title: "Outsourcing / Staff Augmentation",
                desc: "Access specialists or full teams on demand for your projects.",
                link: "Learn more"
              }
            }
          },
          software: {
            systems: {
              title: "Robust Systems and Platforms for Your Business.",
              desc: "We create tailored solutions to automate processes and increase operational efficiency.",
              features: {
                title: "Solutions That Scale with You",
                description: "From ERPs to customized platforms, we develop systems aligned with your business model.",
                items: [
                  {
                    icon: "fal fa-network-wired",
                    title: "Scalable Architecture",
                    desc: "We develop systems prepared to grow with your company."
                  },
                  {
                    icon: "fal fa-cogs",
                    title: "Process Automation",
                    desc: "Eliminate manual tasks with integrated and efficient systems."
                  }
                ]
              },
              analytics: {
                title: "Technology Serving Performance",
                description: "Our solutions generate insights and optimize your business management.",
                items: [
                  {
                    icon: "fal fa-chart-pie",
                    title: "Intelligent Dashboards",
                    desc: "Visualize real-time data and make more assertive decisions."
                  },
                  {
                    icon: "fal fa-plug",
                    title: "Facilitated Integrations",
                    desc: "Connect your system with ERPs, CRMs, and other essential platforms."
                  }
                ]
              }
            },
            apps: {
              title: "Custom Applications for Your Idea or Business.",
              desc: "Transform ideas into functional, intuitive, and scalable applications.",
              features: {
                title: "High-Level Mobile Experience",
                description: "We develop native or hybrid apps focused on performance and usability.",
                items: [
                  {
                    icon: "fal fa-mobile-android",
                    title: "Responsive Design",
                    desc: "Modern interfaces adapted for all devices."
                  },
                  {
                    icon: "fal fa-code",
                    title: "Updated Technology",
                    desc: "We use the best stacks to ensure stability and continuous evolution."
                  }
                ]
              },
              analytics: {
                title: "Data That Drives Your App",
                description: "Monitoring usage, behavior, and continuous improvements.",
                items: [
                  {
                    icon: "fal fa-analytics",
                    title: "Usage Metrics",
                    desc: "Know how users interact with your app and optimize their experience."
                  },
                  {
                    icon: "fal fa-bug",
                    title: "Preventive Maintenance",
                    desc: "Proactive monitoring to correct failures and keep the app performing."
                  }
                ]
              }
            },
            category: "HIGH-END SOFTWARE",
            title: "develop robust, reliable software",
            subtitle: "tailored to your needs.",
            topics: {
              systems: {
                title: "Custom Systems and Platforms",
                desc: "Get a custom-built system designed for your business.",
                link: "Learn more"
              },
              apps: {
                title: "Custom Applications",
                desc: "Create apps that are user-friendly, scalable, and secure.",
                link: "Learn more"
              }
            }
          },
          infrastructure: {
            migration: {
              title: "Secure and Agile Cloud Migration.",
              desc: "Move your infrastructure to the cloud with zero hassle and maximum efficiency.",
              features: {
                title: "Cloud Without Complications",
                description: "Planning, execution, and support at all stages of migration.",
                items: [
                  {
                    icon: "fal fa-cloud-upload",
                    title: "Assisted Migration",
                    desc: "We handle the entire process, minimizing risks and interruptions."
                  },
                  {
                    icon: "fal fa-server",
                    title: "Optimized Infrastructure",
                    desc: "Choose the best cloud architecture for your business."
                  }
                ]
              },
              analytics: {
                title: "Real Gains with the Cloud",
                description: "Track cost reduction, performance, and scalability after migration.",
                items: [
                  {
                    icon: "fal fa-dollar-sign",
                    title: "Measurable Savings",
                    desc: "Cut operational costs with a leaner and more elastic infrastructure."
                  },
                  {
                    icon: "fal fa-tachometer-alt",
                    title: "Guaranteed Performance",
                    desc: "Services with high availability and low response time."
                  }
                ]
              }
            },
            management: {
              title: "Stress-Free Infrastructure Management.",
              desc: "Monitoring, optimization, and continuous support to keep everything running.",
              features: {
                title: "Peace of Mind to Focus on Your Business",
                description: "We take care of your infrastructure so you can focus on growth.",
                items: [
                  {
                    icon: "fal fa-tools",
                    title: "24/7 Support",
                    desc: "Teams ready to act at any time in critical cases."
                  },
                  {
                    icon: "fal fa-sliders-h",
                    title: "Continuous Optimization",
                    desc: "Periodic analyses to reduce bottlenecks and increase performance."
                  }
                ]
              },
              analytics: {
                title: "Total Control of Your Operation",
                description: "Gain visibility into everything happening with your infrastructure.",
                items: [
                  {
                    icon: "fal fa-eye",
                    title: "Active Monitoring",
                    desc: "Real-time alerts and metrics for quick decision-making."
                  },
                  {
                    icon: "fal fa-database",
                    title: "Detailed Reports",
                    desc: "Consolidated information for auditing and continuous improvement."
                  }
                ]
              }
            },
            category: "HIGH-END INFRASTRUCTURE",
            title: "evolve your",
            subtitle: "cloud operations.",
            topics: {
              migration: {
                title: "Cloud Migration",
                desc: "Migrate systems and data to the cloud or between Cloud providers.",
                link: "Learn more"
              },
              management: {
                title: "Manage and Optimize",
                desc: "Cloud management, increase security and reduce costs.",
                link: "Learn more"
              }
            }
          },
          ai: {
            generative: {
              title: "Generative AI Solutions to Transform Your Business.",
              desc: "",
              features: {
                title: "Creation and Automation with AI",
                description: "Apply AI to create content, respond to clients, or generate code automatically.",
                items: [
                  {
                    icon: "fal fa-robot",
                    title: "Intelligent Content",
                    desc: "Generation of texts, images, or ideas with cutting-edge AI."
                  },
                  {
                    icon: "fal fa-magic",
                    title: "Creative Automation",
                    desc: "Optimize repetitive tasks with personalized intelligent assistants."
                  }
                ]
              },
              analytics: {
                title: "Results Beyond Expectations",
                description: "Gain productivity, reduce costs, and surprise your customers.",
                items: [
                  {
                    icon: "fal fa-bolt",
                    title: "Exponential Productivity",
                    desc: "Accelerate workflows with applied artificial intelligence."
                  },
                  {
                    icon: "fal fa-smile",
                    title: "User Experience",
                    desc: "Create unique interactions with generative AI tailored to your audience."
                  }
                ]
              }
            },
            custom: {
              title: "Custom AI for Your Company.",
              desc: "We develop personalized AI models for your data and objectives.",
              features: {
                title: "AI Made for You",
                description: "Machine learning models developed to solve your specific challenges.",
                items: [
                  {
                    icon: "fal fa-brain",
                    title: "Custom Modeling",
                    desc: "Building and training models with your own data."
                  },
                  {
                    icon: "fal fa-puzzle-piece",
                    title: "System Integration",
                    desc: "AI working with your current tools and workflows."
                  }
                ]
              },
              analytics: {
                title: "Smarter Decisions",
                description: "Gain strategic insights with data analyzed by advanced models.",
                items: [
                  {
                    icon: "fal fa-lightbulb",
                    title: "Predictive Analysis",
                    desc: "Anticipate scenarios and make decisions based on real data."
                  },
                  {
                    icon: "fal fa-sync-alt",
                    title: "Continuous Adjustments",
                    desc: "Models that learn and evolve over time for better results."
                  }
                ]
              }
            },

            category: "HIGH-END AI",
            title: "unlock the power of",
            subtitle: "Artificial Intelligence.",
            topics: {
              generative: {
                title: "Generative AI Solutions",
                desc: "Generate insights, automate interpretation of texts, images, and more.",
                link: "Learn more"
              },
              custom: {
                title: "Custom AI Development",
                desc: "AI tailored to your business's specific challenges.",
                link: "Learn more"
              }
            }
          }
        }
      }
    },
    contact: {
      title: "Let's Talk",
      subtitle: "Get in touch with us",
      button: "Contact Us"
    },
    integration: {
      title: "Integrations",
      subtitle: "We connect with the best platforms"
    },
    products: {
      title: "Our Products",
      subtitle: "Complete solutions for your business"
    },
    testimonials: {
      title: "Our Happy Clients say about us.",
      subtitle: "",
      reviews: [
        {
          title: "5 review average in our app",
          text: "Working with InfiniteDev has been an extremely positive experience. The quality of their mobile app development services is outstanding. InfiniteDev is an invaluable partner, and we 100% recommend them to anyone looking for this type of service.",
          author: "Guilherme Ribeiro",
          role: "CEO Rightee Golf"
        },
        {
          title: "The professionalism in executing the work has been excellent",
          text: "At our company, CARDIOHOME SPA, it was essential to incorporate the system developed by InfiniteDev. It streamlined our processes and optimized our time, which is crucial for us, as our services are characterized by extensive patient care.",
          author: "Jorge Kirk",
          role: "CEO Cardiohome"
        }
      ]
    },
    cta: {
      title: "Ready to start?",
      subtitle: "Let's transform your idea into reality",
      button: "Get Started"
    },
    contactButton: {
      text: "Talk to InfiniteDev"
    },
    integrations: {
      title: "Trusted by Industry Leaders Worldwide",
      apps: {
        
          rightee: {
            name: "Rightee",
            description: "Advanced golf GPS and scoring app."
          },
          grupovisco: {
            name: "Grupo Visco",
            description: "CRM, BI Panel, and business automation for Brazil's largest optical laboratory."
          },
          enero: {
            name: "Enero Comunicación",
            description: "Institutional website for an Argentinian Marketing agency."
          },
          calbamerica: {
            name: "Calbamerica",
            description: "Latin American Lithium Chamber - Digital Transformation."
          },
          mmarg: {
            name: "Mercado de Metales",
            description: "Investor fundraising system for mining."
          },
          tecnoedil: {
            name: "Tecnoedil",
            description: "Quotation and provider registration platform."
          },
          cardiohome: {
            name: "Cardiohome",
            description: "Platform for medical evaluations in a school environment."
          },
          xhockware: {
            name: "Xhockware",
            description: "Global leader in software for Retail."
          },
          youbeep: {
            name: "YouBeep",
            description: "Innovation in checkout solutions for retail."
          },
          quilmes: {
            name: "Quilmes",
            description: "Largest brewery in Argentina."
          },
          gob: {
            name: "Gobierno BsAs",
            description: "Digital services for citizens."
          }
        
      }
    },
    cases: {
      title: "Cases that prove competence",
      products: [
        {
          title: "Rightee",
          description: "We developed a complete golf app with high-precision GPS, digital scorecard and advanced statistics. Our solution enabled handicap evolution and real-time tournament management."
        },
        {
          title: "Cardiohome",
          description: "We created an integrated system for managing medical assessments in schools, with automated report generation and intuitive interface for healthcare professionals."
        },
        {
          title: "Visco Group",
          description: "We created CRM, BI, and automations that integrated processes and increased efficiency for the largest optical lab in Brazil."
        }
      ]
    },
    cyberCta: {
      title: "Discuss Your Project with Our Experts",
      subtitle: "Receive a technical analysis and a clear roadmap for your solution.",
      button: "Contact Us"
    },
    footer: {
      newsletter: {
        title: "Our latest news, articles, and resources, we will sent to your inbox weekly.",
        placeholder: "Enter your email",
        button: "Subscribe"
      },
      rating: {
        title: "10/10 Overall rating"
      },
      sections: {
        primary: {
          title: "Primary Pages",
          links: {
            home: "Home",
            about: "About Us",
            services: "Services",
            career: "Career",
            integrations: "Integrations",
            integrationSingle: "Integration Single"
          }
        },
        pages: {
          title: "Pages",
          links: {
            pricing: "Pricing",
            blog: "Blog",
            blogDetails: "Blog Details",
            contact: "Contact",
            careerSingle: "Career Single",
            serviceSingle: "Services Single"
          }
        },
        template: {
          title: "Template",
          links: {
            contact: "Contact",
            support: "Support",
            supportSingle: "Support Single",
            comingSoon: "Coming Soon",
            login: "User Login",
            careerSingle: "Career Single"
          }
        }
      },
      copyright: "© 2025 InfiniteDev. All rights reserved."
    },
    services: {
      agronegocio: {
        title: "Agribusiness",
        desc: "Innovative technological solutions for the agricultural sector, optimizing processes and increasing productivity.",
        features: {
          title: "Advanced Technology for the Field",
          description: "We implement digital solutions that revolutionize agricultural management, from planting to harvesting.",
          items: [
            {
              icon: "fal fa-tractor",
              title: "Production Management",
              desc: "Total production control with real-time monitoring."
            },
            {
              icon: "fal fa-chart-line",
              title: "Data Analysis",
              desc: "Valuable insights for data-driven decision making."
            }
          ]
        },
        analytics: {
          title: "Advanced Analysis for Results",
          description: "We use cutting-edge technology to optimize each stage of the agricultural process.",
          items: [
            {
              icon: "fal fa-comments-alt",
              title: "Specialized Support",
              desc: "Technical team specialized in agribusiness."
            },
            {
              icon: "fal fa-headset",
              title: "24/7 Monitoring",
              desc: "Continuous monitoring of your production."
            }
          ]
        }
      },
      educacao: {
        title: "Education",
        desc: "Transforming education through innovative technology and customized digital solutions.",
        features: {
          title: "Modern Educational Platforms",
          description: "We develop solutions that revolutionize the way of teaching and learning.",
          items: [
            {
              icon: "fal fa-graduation-cap",
              title: "Complete E-Learning",
              desc: "Complete platforms for distance learning."
            },
            {
              icon: "fal fa-book",
              title: "School Management",
              desc: "Integrated system for educational administration."
            }
          ]
        },
        analytics: {
          title: "Educational Performance Analysis",
          description: "Advanced tools for tracking student progress.",
          items: [
            {
              icon: "fal fa-chart-bar",
              title: "Learning Metrics",
              desc: "Detailed tracking of student performance."
            },
            {
              icon: "fal fa-users",
              title: "Collaboration",
              desc: "Tools for interaction between students and teachers."
            }
          ]
        }
      },
      logistica: {
        title: "Logistics",
        desc: "Smart solutions for supply chain optimization and transportation management.",
        features: {
          title: "Smart Logistics",
          description: "Advanced systems for efficient supply chain management.",
          items: [
            {
              icon: "fal fa-truck",
              title: "Tracking",
              desc: "Real-time delivery monitoring."
            },
            {
              icon: "fal fa-route",
              title: "Routing",
              desc: "Route optimization for greater efficiency."
            }
          ]
        },
        analytics: {
          title: "Logistics Performance Analysis",
          description: "Advanced metrics for process optimization.",
          items: [
            {
              icon: "fal fa-map-marked-alt",
              title: "Fleet Management",
              desc: "Complete control of your vehicle fleet."
            },
            {
              icon: "fal fa-box",
              title: "Inventory Management",
              desc: "Precise control of inventory and storage."
            }
          ]
        }
      },
      streaming: {
        title: "Streaming",
        desc: "High-performance streaming platforms with cutting-edge technology.",
        features: {
          title: "High-Quality Streaming",
          description: "Complete solutions for real-time content transmission.",
          items: [
            {
              icon: "fal fa-video",
              title: "HD Transmission",
              desc: "Premium image and sound quality."
            },
            {
              icon: "fal fa-broadcast-tower",
              title: "Low Latency",
              desc: "Real-time transmission with minimal latency."
            }
          ]
        },
        analytics: {
          title: "Engagement Analysis",
          description: "Detailed audience and engagement metrics.",
          items: [
            {
              icon: "fal fa-eye",
              title: "Audience Metrics",
              desc: "Detailed analysis of viewer behavior."
            },
            {
              icon: "fal fa-chart-pie",
              title: "Reports",
              desc: "Complete performance reports."
            }
          ]
        }
      },
      "varejo-e-moda": {
        title: "Retail & Fashion",
        desc: "Innovative digital solutions for the retail and fashion sector.",
        features: {
          title: "Digital Retail",
          description: "Transform your operation with cutting-edge technology.",
          items: [
            {
              icon: "fal fa-shopping-cart",
              title: "E-commerce",
              desc: "Complete online sales platforms."
            },
            {
              icon: "fal fa-tshirt",
              title: "Inventory Management",
              desc: "Precise control of products and collections."
            }
          ]
        },
        analytics: {
          title: "Sales Analysis",
          description: "Valuable insights for strategic decisions.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Sales Metrics",
              desc: "Detailed analysis of commercial performance."
            },
            {
              icon: "fal fa-users",
              title: "Customer Behavior",
              desc: "Deep understanding of your audience."
            }
          ]
        }
      },
      "bets-igaming": {
        title: "Betting & iGaming",
        desc: "Secure and innovative platforms for the online betting and gaming sector.",
        features: {
          title: "High-Performance Gaming",
          description: "Complete solutions for betting and gaming operators.",
          items: [
            {
              icon: "fal fa-dice",
              title: "Complete Platform",
              desc: "Integrated system for betting management."
            },
            {
              icon: "fal fa-shield-alt",
              title: "Security",
              desc: "Advanced protection for online operations."
            }
          ]
        },
        analytics: {
          title: "Performance Analysis",
          description: "Advanced metrics for operation optimization.",
          items: [
            {
              icon: "fal fa-chart-bar",
              title: "Gaming Metrics",
              desc: "Detailed analysis of player behavior."
            },
            {
              icon: "fal fa-user-shield",
              title: "Compliance",
              desc: "Guarantee of compliance with regulations."
            }
          ]
        }
      },
      financeiro: {
        title: "Financial",
        desc: "Secure technological solutions for the financial sector.",
        features: {
          title: "Financial Technology",
          description: "Advanced systems for financial management.",
          items: [
            {
              icon: "fal fa-wallet",
              title: "Financial Management",
              desc: "Complete control of financial operations."
            },
            {
              icon: "fal fa-shield-alt",
              title: "Security",
              desc: "Advanced protection for financial data."
            }
          ]
        },
        analytics: {
          title: "Financial Analysis",
          description: "Valuable insights for financial decisions.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Financial Metrics",
              desc: "Detailed analysis of financial performance."
            },
            {
              icon: "fal fa-file-invoice-dollar",
              title: "Reports",
              desc: "Complete operation reports."
            }
          ]
        }
      },
      startups: {
        title: "Startups",
        desc: "Innovative technological solutions to boost your business.",
        features: {
          title: "Technology for Startups",
          description: "Essential tools for your business growth.",
          items: [
            {
              icon: "fal fa-rocket",
              title: "Scalability",
              desc: "Solutions that grow with your business."
            },
            {
              icon: "fal fa-lightbulb",
              title: "Innovation",
              desc: "Cutting-edge technologies for your business."
            }
          ]
        },
        analytics: {
          title: "Growth Analysis",
          description: "Metrics to track development.",
          items: [
            {
              icon: "fal fa-chart-line",
              title: "Growth Metrics",
              desc: "Tracking of business development."
            },
            {
              icon: "fal fa-users",
              title: "Engagement",
              desc: "Analysis of user behavior."
            }
          ]
        }
      },
      tecnologia: {
        title: "Technology",
        desc: "Cutting-edge technological solutions for technology companies.",
        features: {
          title: "Technological Innovation",
          description: "Advanced solutions for technology companies.",
          items: [
            {
              icon: "fal fa-microchip",
              title: "Development",
              desc: "Soluções personalizadas para seu negócio."
            },
            {
              icon: "fal fa-cloud",
              title: "Cloud",
              desc: "High-performance cloud infrastructure."
            }
          ]
        },
        analytics: {
          title: "Performance Analysis",
          description: "Métricas avançadas para otimização.",
          items: [
            {
              icon: "fal fa-tachometer-alt",
              title: "Performance",
              desc: "Monitoramento de desempenho em tempo real."
            },
            {
              icon: "fal fa-chart-bar",
              title: "Métricas",
              desc: "Análise detalhada de sistemas."
            }
          ]
        }
      }
    },
    contactForm: {
      title: "Submit Form",
      fields: {
        name: "Name",
        email: "Email",
        companyWebsite: "Company website",
        workEmail: "Work email",
        budget: "Budget",
        country: "Country",
        message: "Tell us more about your project, needs and budget",
        budgetOptions: {
          default: "Budget",
          started: "None, just getting started",
          less20k: "Less than $20,000",
          less50k: "$20,000 to $50,000",
          less100k: "$50,000 to $100,000",
          less500k: "$100,000 to $500,000",
          more500k: "More than $500,000"
        }
      },
      privacy: {
        text: "Yes, I'd like to receive occasional marketing emails from us. I have the right to opt out at any time.",
        link: "View privacy policy"
      },
      submit: "Send",
      sending: "Sending"
      
    },
    reviewTab: {
      title: "Start Your Project with Us",
      description: "Whatever your goal or project size we will handle it utilizing standards compliant. We hope you will be 100% satisfied.",
      testimonials: [
        {
          quote: "Working with InfiniteDev has been an extremely positive experience. The quality of their mobile app development services is outstanding. InfiniteDev is an invaluable partner, and we 100% recommend them to anyone looking for this type of service.",
          author: "Guilherme Ribeiro",
          role: "CEO Rightee Golf"
        },
        {
          quote: "Synergistically evisculate market positioning technology vis-a-vis team driven innovation. Phosfluorescently morph tactical communities for superior applications. Distinctively pontificate resource-leveling infomediaries and parallel models.",
          author: "Raymond H. Gilbert",
          role: "CEO Cardiohome"
        }
      ]
    },
    promoThree: {
      title: "Everything We Do it With Love",
      description: "Progressively deploy market positioning catalysts for change and technically sound authoritatively e-enable resource-leveling infrastructures.",
      cards: [
        {
          number: "150+",
          title: "Completed Projects",
          description: "Rapidiously embrace distinctive best practices after B2B syndicate."
        },
        {
          number: "1.5k",
          title: "Happy Client",
          description: "Energistically impact synergistic convergence for leadership."
        },
        {
          number: "99.9%",
          title: "Platform Uptime",
          description: "We ensure high availability so your operation never stops."
        }
      ]
    }
  }
};
